export default __webpack_public_path__ + "static/media/03_longpress.3f0dffbe.png";